<h1 mat-dialog-title>{{ data.title }}</h1>

<mat-dialog-content>
  <form class="flex flex-col gap-4" [formGroup]="form">
    <div class="space-y-2">
      <label for="name" class="block font-medium text-sm select-none">Naam</label>

      <mat-form-field class="w-full">
        <input
          matInput
          formControlName="name"
          autocomplete="off"
          enterkeyhint="next"
          id="name"
          type="text"
        />

        @if (controls.name.hasError('required')) {
          <mat-error>Dit veld is verplicht</mat-error>
        } @else if (controls.name.hasError('maxlength')) {
          <mat-error
            >Max.
            {{ controls.name.getError('maxlength').requiredLength }}
            karakters</mat-error
          >
        }
      </mat-form-field>
    </div>

    <div class="space-y-2">
      <label for="phoneNumber" class="block font-medium text-sm select-none"
        >Telefoonnummer</label
      >

      <mat-form-field class="w-full">
        <app-phone-input
          formControlName="phoneNumber"
          inputId="phoneNumber"
          searchable
        ></app-phone-input>

        @if (controls.phoneNumber.hasError('required')) {
          <mat-error>Dit veld is verplicht</mat-error>
        } @else if (controls.phoneNumber.hasError('invalidPhone')) {
          <mat-error>Vul een geldig telefoonnummer in</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="space-y-2">
      <label for="email" class="block font-medium text-sm select-none"
        >E-mailadres
        <span class="text-gray-500 text-xs font-normal">(optioneel)</span></label
      >

      <mat-form-field class="w-full">
        <input
          matInput
          formControlName="email"
          autocomplete="off"
          enterkeyhint="next"
          placeholder="voorbeeld@domein.com"
          id="email"
          type="email"
        />

        @if (controls.email.hasError('email')) {
          <mat-error>Vul een geldig e-mailadres in</mat-error>
        }
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close [disabled]="submitted()">Annuleren</button>

  <button mat-button (click)="handleConfirm()" [disabled]="submitted() || form.invalid">
    <mat-spinner
      class="!absolute inset-0 m-auto pointer-events-none transition-opacity ease-in-out"
      [diameter]="16"
      [class.opacity-100]="loading()"
      [class.opacity-0]="!loading()"
    ></mat-spinner>

    <span [class.opacity-0]="loading()" class="transition-opacity">Opslaan</span>
  </button>
</mat-dialog-actions>
